<template>
  <div class="wrap">
    <div class="header">
      <div class="header-page-title">
        <p>{{header_title}}</p>
      </div>
      <img src="../assets/image/Lx-Success/sub-success.png"/>
      <p>感谢</p>
      <p>您的申请已提交</p>
    </div>
    <div class="main">
      <p>我们将安排专人服务您本次金融购车</p>
      <p>请留意接听021-3183开头的电话号码</p>
      <p v-if="loan_amount > 195000"><span>*</span>鉴于您申请的贷款额度大于19万5，请您准备好3个月以上的纸质流水证明 或 网银流水截图</p>
      <button @click="closeOrder">关闭</button>
    </div>
    <div class="footer">
      <div>
        <p>江南银行分期业务由灿谷金服提供相关服务</p>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Lx_Success',
    data() {
      return {
        header_title: '江南银行',
        loan_amount: 0
      }
    },
    mounted() {
      window.scrollTo(0, 0)
      this.$nextTick(function () {
        this.loan_amount = sessionStorage.getItem("loan_amount")
      })

    },
    methods: {
      closeOrder() {
        const router = this.$router;
        window.location.href = sessionStorage.getItem("backurl")
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  p {
    margin: 0;
  }

  .header {
    margin: 0 auto;
    padding: 0;
    width: 7.50rem;
    text-align: center;
    font-size: 0;
  }

  .header-page-title {
    margin: 0;
    padding: 0;
    height: 1.28rem;
  }

  .header-page-title > p {
    padding-top: 0.20rem;
    width: 100%;
    font-size: 0.42rem;
    font-weight: 600;
    line-height: 1.08rem;
    color: #222;
    text-align: center;
  }

  .wrap > .header > img {
    margin: 0 auto;
    margin-top: 0.82rem;
    width: 1.28rem;
    height: 1.28rem;
  }

  .wrap > .header > p {
    font-weight: 600;
    color: #000000;
    letter-spacing: -0px;
    text-align: center;
  }

  .wrap > .header > p {
    margin-top: 0.63rem;
    font-size: 0.42rem;
    line-height: 0.59rem;
  }

  .wrap > .header > p:last-child {
    margin-top: 0.22rem;
    font-size: 0.38rem;
    line-height: 0.53rem;
  }

  .wrap > .main {
    text-align: center;
  }
  .wrap > .main > p {
    font-weight: 600;
    color: #000000;
    letter-spacing: -0px;
    text-align: center;
  }

  .wrap > .main > p:first-child {
    margin-top: 0.95rem;
    font-size: 0.38rem;
    line-height: 0.53rem;
  }

  .wrap > .main > p:nth-child(2) {
    margin-top: 0.22rem;
    font-size: 0.28rem;
    font-weight: 400;
    line-height: 0.40rem;
  }

  .wrap > .main > p:nth-child(3) {
    margin: 0 auto;
    margin-top: 1.27rem;
    width: 5rem;
    font-size: 0.22rem;
    font-weight: 400;
    line-height: 0.3rem;
    text-align: left;
  }

  .wrap > .main > p:nth-child(3) > span {
    color: #f07676;
    text-align: left;
  }

  .wrap > .main > button {
    padding: 0;
    margin-top: 1.73rem;
    width: 5.61rem;
    height: 0.9rem;
    background: #2594FF;
    border-radius: 6px;
    border-width: 0;
    font-size: 0.32rem;
    color: #FFFFFF;
    letter-spacing: -0px;
    text-align: center;
  }

  .wrap > .footer{
    margin-top: 0.94rem;
    padding-bottom: 1rem;
    font-size: 0;
    text-align: center;
  }
  .wrap > .footer > div > p {
    opacity: 0.6;
    font-size: 0.22rem;
    color: #000000;
    letter-spacing: -0px;
    text-align: center;
    line-height: 0.32rem;
  }


</style>



// WEBPACK FOOTER //
// src/components/Lx-Success.vue